// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__-g41k","text":"styles_text__l4Fz3","time":"styles_time__2Ms42"};